export default "__VITE_ASSET__CaiezfGJ__"